import styled from 'styled-components';

interface Props {
  mode?: String,
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  position: relative;
  
  @media only screen and (max-width: 767px) {
    padding: 40px 0;
  }
`;

const ImageWrapper = styled.div`
  display: ${(props: Props) => props.mode === 'desktop' ? 'flex': 'none'};

  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 80%;

  @media only screen and (max-width: 767px) {
    width: 100%;
    display: ${(props: Props) => props.mode === 'mobile' ? 'flex': 'none'};
  }
`;

const Image = styled.img`
  width: 100%;
`;

const Board = styled.div`
  background: #fff;
  width: calc(100% - 54px);
  height: 35%;
  position: absolute;
  bottom: 40px;
  left: 27px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 691px) and (max-width: 767px) {
    height: 45%;
    bottom: 80px;
  }

  @media only screen and (min-width: 561px) and (max-width: 690px) {
    height: 45%;
    bottom: 60px;
  }

  @media only screen and (min-width: 351px) and (max-width: 560px) {
    height: 45%;
    bottom: 40px;
  }

  @media only screen and (max-width: 350px) {
    height: 45%;
    bottom: 30px;
  }
`;

const Number = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 90%;

  @media only screen and (max-width: 767px) {
    justify-content: flex-end;
    width: 85%;
    flex: 1;
  }
`;

const Count = styled.div`
  font-weight: bold;
  color: #333;
  text-align: right;
  line-height: 1.3;
  font-size: 2.5rem;
  letter-spacing: -1.3px;
  margin-bottom: 10px;
  margin-right: 10px;
  width: 40%;

  @media only screen and (min-width: 768px) and (max-width: 1000px) {
    font-size: 2.1rem;
    margin-bottom: 5px;
  }

  @media only screen and (min-width: 691px) and (max-width: 767px) {
    font-size: 2.3rem;
    width: 100%;
    flex: 1;
    line-height: 1;
    margin-bottom: 0;
    margin-right: 0;
    padding: 0 0 5px 0;
  }

  @media only screen and (min-width: 561px) and (max-width: 690px) {
    font-size: 2rem;
    width: 100%;
    flex: 1;
    line-height: 1;
    margin-bottom: 0;
    margin-right: 0;
    padding: 0 0 5px 0;
  }

  @media only screen and (min-width: 351px) and (max-width: 560px) {
    font-size: 1.8rem;
    width: 100%;
    flex: 1;
    line-height: 1;
    margin-bottom: 0;
    margin-right: 0;
    padding: 0 0 5px 0;
  }

  @media only screen and (max-width: 350px) {
    font-size: 1.8rem;
    width: 100%;
    flex: 1;
    line-height: 1;
    margin-bottom: 0;
    margin-right: 0;
    padding: 0 0 5px 0;
  }
`;

const Label = styled.div`
  font-weight: 400;
  color: #333;
  text-align: center;
  line-height: 1.3;
  font-size: 1.25rem;
  margin-bottom: 10px;
  border-bottom: 1px solid #333;
  padding: 3px 5px;

  @media only screen and (min-width: 767px) and (max-width: 1000px) {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  @media only screen and (min-width: 691px) and (max-width: 767px) {
    font-weight: 500;
    font-size: 1.1rem;
    margin-bottom: 0;
    margin-right: 10px;
    padding: 5px;
  }

  @media only screen and (min-width: 561px) and (max-width: 690px) {
    font-weight: 500;
    font-size: 1rem;
    margin-bottom: 0;
    margin-right: 10px;
    padding: 5px;
  }

  @media only screen and (min-width: 351px) and (max-width: 560px) {
    font-weight: 500;
    font-size: 0.8rem;
    margin-bottom: 0;
    margin-right: 10px;
    padding: 5px;
  }

  @media only screen and (max-width: 350px) {
    font-weight: 500;
    font-size: 0.8rem;
    margin-bottom: 0;
    margin-right: 10px;
    padding: 5px;
  }
`;

const Circle = styled.div`
  background: #fff;
  width: 22%;
  height: 22%;
  border-radius: 50%;
  position: absolute;
  top: 20%;
  left: 38.5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 767px) {
    top: 13%;
    left: 39.5%;
  }

  &:nth-of-type(1) {
    left: 7%;
  }

  &:last-child {
    left: 71%;
  }
`;

const CircleTitle = styled.h3`
  font-size: 24px;
  margin-bottom: 5px;
  letter-spacing: -0.5px;
  
  @media only screen and (min-width: 501px) and (max-width: 767px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 500px) {
    font-size: 16px;
  }
`;

const CircleNumber = styled.h1`
  color: #05D6E1;
  font-weight: bold;
  font-size: 42px;
  letter-spacing: -0.3px;

  @media only screen and (min-width: 501px) and (max-width: 767px) {
    font-size: 36px;
  }

  @media only screen and (max-width: 500px) {
    font-size: 28px;
  }
`;

const LineBreak = styled.br`
  display: none;

  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

const Interview = styled.div`
  background-color: transparent;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${(props: Props) => props.mode === 'mobile' ? '100%' : '30%'};
  cursor: pointer;
  z-index: 1000;
  display: flex;
  flex-direction: ${(props: Props) => props.mode === 'mobile' ? 'column' : 'row'};
`;

const InterviewItem = styled.div`
  flex: 1;
`;

export {
  Content,
  ImageWrapper,
  Image,
  Board,
  Number,
  Count,
  Label,
  Circle,
  CircleTitle,
  CircleNumber,
  LineBreak,
  Interview,
  InterviewItem,
};

